import PropTypes from "prop-types"
import MuiTextField from "@mui/material/TextField";

export function TextField({
  label,
  value,
  onChange,
  type = "text",
  fullWidth = true,
  shrink = false,
  InputLabelProps,
  ...rest
}) {
  const shouldShrinkLabel = shrink || type === "date";
  const mergedInputLabelProps = shouldShrinkLabel
    ? { ...InputLabelProps, shrink: true }
    : InputLabelProps;

  return (
    <MuiTextField
      label={label}
      variant="outlined"
      fullWidth={fullWidth}
      type={type}
      InputLabelProps={mergedInputLabelProps}
      value={value}
      onChange={onChange}
      {...rest}
    />
  );
}

TextField.propTypes = {
  fullWidth: PropTypes.bool,
  InputLabelProps: PropTypes.object,
  label: PropTypes.any,
  onChange: PropTypes.any,
  shrink: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.any
}
